module.exports = __webpack_public_path__ + "static/media/highpark.23d6f6a6.jpg";